export var actionTypePrefix = '@@Comments2';
export var reduxKey = '@@Comments2';
export var actionMenuWidthMobile = 'auto';
export var actionMenuWidthDesktop = 140;
//# sourceMappingURL=constants.js.map